import React from 'react';
import { Link } from 'react-router-dom';
import beneficiosEquipo from '../assets/benefits/beneficios-equipo-570x350.png';

const Benefits = () => {
  const benefits = [
    {
      icon: '🛠️',
      title: 'Instalación Profesional',
      description: 'Nuestro equipo técnico certificado garantiza una instalación correcta y eficiente de todos los equipos de seguridad.',
    },
    {
      icon: '💰',
      title: 'Sin Pago Inicial',
      description: 'Accede a nuestros servicios de renta sin necesidad de realizar una inversión inicial. Comienza a proteger tu patrimonio hoy mismo.',
    },
    {
      icon: '🔧',
      title: 'Soporte Técnico Continuo',
      description: 'Contamos con servicio de soporte técnico especializado para resolver cualquier duda o problema de forma rápida y eficiente.',
    },
    {
      icon: '📱',
      title: 'Equipos Modernos',
      description: 'Trabajamos con las mejores marcas y equipos de última generación con tecnología de punta en videovigilancia.',
    },
    {
      icon: '⚡',
      title: 'Atención Inmediata',
      description: 'Respuesta rápida a tus solicitudes con tiempos de instalación y atención que se adaptan a tu disponibilidad.',
    },
  ];

  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">¿Por Qué Elegirnos?</h1>
          <p className="page-subtitle">
            Descubre los beneficios de confiar en TecnoVigilancia 360
          </p>
        </div>
      </section>

      <section className="benefits-intro">
        <div className="container">
          <div className="intro-content">
            <h2 className="section-title">Tu Seguridad es Nuestra Prioridad</h2>
            <p className="section-text">
              En TecnoVigilancia 360 nos diferenciamos por ofrecer un servicio integral
              que va más allá de la simple instalación de equipos. Nos preocupamos por
              brindarte tranquilidad y protección constante con la mejor tecnología y
              atención personalizada.
            </p>
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="container">
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="advantages-section">
        <div className="container">
          <h2 className="section-title">Ventajas Adicionales</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Experiencia Comprobada</h4>
                <p>Años de trayectoria respaldando a cientos de clientes satisfechos</p>
              </div>
            </div>

            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Garantía Total</h4>
                <p>Todos nuestros equipos e instalaciones cuentan con garantía</p>
              </div>
            </div>

            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Precios Competitivos</h4>
                <p>Planes de renta desde $400 mensuales y opciones de financiamiento</p>
              </div>
            </div>

            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Monitoreo Remoto</h4>
                <p>Accede a tus cámaras desde cualquier dispositivo, en cualquier momento</p>
              </div>
            </div>

            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Mantenimiento Incluido</h4>
                <p>En planes de renta, el mantenimiento preventivo está incluido</p>
              </div>
            </div>

            <div className="advantage-item">
              <span className="check-large">✓</span>
              <div className="advantage-content">
                <h4>Asesoría Personalizada</h4>
                <p>Te ayudamos a elegir la mejor solución según tus necesidades</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          <h2 className="section-title">Nuestro Compromiso</h2>
          <div className="commitment-box">
            <p className="commitment-text">
              "En TecnoVigilancia 360 nos comprometemos a ofrecer soluciones de seguridad
              confiables, accesibles y de la más alta calidad. Tu tranquilidad es nuestro
              éxito, y trabajamos cada día para garantizar la protección de lo que más valoras."
            </p>
            <div className="commitment-image">
              <img
                src={beneficiosEquipo}
                alt="Equipo profesional certificado y herramientas de TecnoVigilancia 360"
                style={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">¿Listo para comenzar?</h2>
          <p className="cta-text">
            Contáctanos y descubre cómo podemos ayudarte a proteger tu hogar o negocio
          </p>
          <Link to="/contact" className="btn btn-cta">
            Contáctanos Ahora
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Benefits;
